<template>
  <div class="main mt-3 text-left">
    <div class="kkv-description-section">
      <b-container>
        <b-row class="mb-12">
          <b-col sm="12" md="12" lg="7">
            <h1>KKV Minősítő</h1>

            <h3 class="mt-4">
              Tudja meg gyorsan és egyszerűen, hogy a hivatalosan leadott adatok alapján cége mikro-, kis-, közép-, vagy
              nagyvállalkozásnak minősül. Mérje fel, hogy mikro-, kis-, középvállalkozások, vagy nagyvállatok számára
              elérhető támogatásokkal, pénzügyi eszközökkel érdemes-e terveznie cége fejlesztését.
            </h3>

            <div class="svg d-block d-lg-none text-center mt-5  d-flex justify-content-center">
              <div class="w-50">
                <kkv-teaser-copy-svg />
              </div>
            </div>

            <b-col class="mb-4 pl-0 mt-5">
              <b-row>
                <div class="constant-services-holder-box">
                  <h3>Cégadatok értelmezése</h3>
                </div>
              </b-row>
              <b-row>
                <div class="constant-services-holder-box">
                  <h3>Cégháló feltérképezése</h3>
                </div>
              </b-row>
              <b-row class="mb-5">
                <div class="constant-services-holder-box">
                  <h3>Gyors és egyszerű indikatív online cégbesorolás</h3>
                </div>
              </b-row>
            </b-col>
          </b-col>
          <b-col sm="6" md="6" lg="5" class="svg d-none d-lg-block">
            <kkv-teaser-svg />
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="kkv-login-section" v-if="!isAuthenticated">
      <b-container class="mt-5">
        <b-row>
          <b-col sm="12" md="12" lg="7">
            <h2>
              Lépjen be a vali.hu fiókjába a személyre szabott KKV besorolásáért
            </h2>

            <b-col class="mb-4">
              <div style="display: flex;margin-left: -30px">
                <ifka-vp-login-form :kkv-form="true" />
              </div>
            </b-col>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="kkv-login-section-loggedin" v-if="isAuthenticated">
      <b-container class="mt-2">
        <b-row>
          <b-col sm="12" md="12" lg="12">
            <div class="rounded bg-color-lightblue p-5 pb-3">
              <template
                v-if="
                  userCompanyOptions !== null && userCompanyOptions !== undefined && userCompanyOptions.length !== 0
                "
              >
                <h2 class="mb-0">
                  Válassza ki az indikatív besorolás vizsgálathoz cégét...
                </h2>
                <label class="mt-5">Másik cég kiválasztása</label>
                <select-company currentPage="kkv-qualifier"></select-company>
                <h2 class="mb-1 mt-5">...vagy adjon hozzá egy új céget a profiljához</h2>
              </template>
              <template v-else>
                <h2>Adjon hozzá egy új céget a profiljához a besorolás megkezdéséhez</h2>
              </template>

              <search-company currentPage="kkv-qualifier"></search-company>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import LoginForm from '../components/LoginForm.vue'
import KkvTeaserSvg from '@/components/svg/Kkv/KkvTeaser.vue'
import { mapGetters } from 'vuex'
import SelectCompany from '@/components/SelectCompany.vue'
import SearchCompany from '@/components/SearchCompany.vue'
import KkvTeaserCopySvg from '@/components/svg/Kkv/KkvTeaserCopy.vue'

export default {
  name: 'PublicKkv',
  components: {
    ifkaVpLoginForm: LoginForm,
    KkvTeaserSvg,
    SelectCompany,
    SearchCompany,
    KkvTeaserCopySvg
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'userCompanyOptions', 'userCompanies', 'selectedUserCompany']),
    authChange() {
      return this.isAuthenticated
    }
  },
  async created() {
    if (this.isAuthenticated) {
      const getParams = {}
      await this.$store.dispatch('getUserCompanies', getParams)
      if (this.userCompanies[0] && !this.selectedUserCompany) {
        this.$store.commit('setSelectedUserCompany', this.userCompanies[0])
      }
    }
  },
  watch: {
    async authChange(newVal, old) {
      if (newVal && !old) {
        const getParams = {}
        await this.$store.dispatch('getUserCompanies', getParams)
      }
    }
  }
}
</script>

<style scoped>
.constant-services-holder-box {
  padding: 15px;
  position: relative;
  padding-left: 75px;
}

.constant-services-holder-box:before {
  content: ' ';
  display: block;
  position: absolute;
  right: 0;
  top: 25%;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-image: url('../assets/img/logo/vekonyvali_hollow.svg');
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 50px;
}

.kkv-description-section {
  border-bottom-right-radius: 100px;
  background-color: var(--white);
}

.kkv-login-section {
  position: relative;
  background-color: var(--color-lightblue);
  margin-bottom: -20px;
  padding: 20px;
  border-top-left-radius: 100px;
}

.kkv-login-section-loggedin {
  position: relative;
  background-color: var(--white);
  margin-bottom: -20px;
  padding: 20px;
  border-top-left-radius: 100px;
}

.svg {
  text-align: right;
}

@media (max-width: 991px) {
  .kkv-description-section {
    margin-top: 6rem;
  }

  .kkv-login-section-loggedin {
    margin-left: -35px;
    margin-right: -35px;
  }
}
</style>
